import { Api } from "../axios-config";
import { IContent } from "../contents/Contents.services";
const removeCoursePicture = async (id: string): Promise<ICourses | Error> => {
    try {
        const response = await Api.delete(`/courses/${id}/picture`);
        return response.data;
    } catch (error) {
        return new Error(`Error removing course picture: ${error}`);
    }
}
export interface ICourses {
    _id: string;
    PictureId?: string;
    Name: string;
    Description: string;
    Workload: number;
    TrainingAreaId?: string;
    Contents: IContent[];
    IsDeleted: boolean;
}

export interface IListCourses {
    data: ICourses[];
}

const getAllCourses = async (): Promise<IListCourses | Error> => {
    try {
        const urlRelativa = `/courses`;
        const { data } = await Api.get(urlRelativa);
        if (data){
            const adaptedData = Array.isArray(data) ? data : [];
            return { data: adaptedData };
        }else{            
            return new Error('Erro ao Listar');
        }
    } catch (error) {
        return new Error(`Error getting all courses: ${error}`);
    }
}

const getCourseById = async (id: string): Promise<ICourses | Error> => {
    try {
        
        const response = await Api.get(`/courses/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Error getting course by id: ${error}`);
    }
}

const getCoursesByTrainingAreaId = async (trainingAreaId: string): Promise<IListCourses | Error> => {
    try {
        const response = await Api.get(`/courses/training-area/${trainingAreaId}`);
        const adaptedData = Array.isArray(response.data) ? response.data : [];
        return { data: adaptedData };
    } catch (error) {
        return new Error(`Error getting courses by training area id: ${error}`);
    }
}
const searchCourses = async (search: string): Promise<IListCourses | Error> => {
    try {
        const response = await Api.get(`/courses/search`, {
            params: {
                name: search // Corrigido para 'name'
            }
        });
        if (response.data) {
            const adaptedData = Array.isArray(response.data) ? response.data : [];
            return { data: adaptedData };
        } else {
            return new Error('Erro ao buscar cursos');
        }
    } catch (error) {
        return new Error(`Error searching courses: ${error}`);
    }
}
const createCourse = async (Name: string, Description: string, Workload: number, TrainingAreaId?: string, PictureId?: string): Promise<ICourses | Error> => {
    try {
        const response = await Api.post('/courses', {
            Name,
            Description,
            Workload,
            TrainingAreaId,
            PictureId
        });
        return response.data;
    } catch (error) {
        return new Error(`Error creating course: ${error}`);
    }
}

const updateCourse = async (
    id: string,
    Name?: string,
    Description?: string,
    Workload?: number,
    TrainingAreaId?: string,
    PictureId?: string | null
): Promise<ICourses | Error> => {
    try {
        const response = await Api.put(`/courses/${id}`, {
            Name: Name || null,
            Description: Description || null,
            Workload: Workload || null,
            TrainingAreaId: TrainingAreaId || null,
            PictureId: PictureId === undefined ? null : PictureId
        });
        return response.data;
    } catch (error) {
        return new Error(`Error updating course: ${error}`);
    }
};

const deleteCourse = async (id: string): Promise<ICourses | Error> => {
    try {
        const response = await Api.delete(`/courses/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Error deleting course: ${error}`);
    }
}

const addContentToCourse = async (courseId: string, contentId: string): Promise<ICourses | Error> => {
    try {
        const response = await Api.post('/courses/contents/add', {
            courseId,
            contentId
        });
        return response.data;
    } catch (error) {
        return new Error(`Error adding content to course: ${error}`);
    }
}

const removeContentFromCourse = async (courseId: string, contentId: string): Promise<ICourses | Error> => {
    try {
        const response = await Api.delete('/courses/contents/remove', {
            data: { courseId, contentId }
        });
        return response.data;
    } catch (error) {
        return new Error(`Error removing content from course: ${error}`);
    }
}

export const CoursesServices = {
    getAllCourses,
    getCourseById,
    getCoursesByTrainingAreaId,
    searchCourses,
    createCourse,
    updateCourse,
    deleteCourse,
    addContentToCourse,
    removeContentFromCourse
    ,removeCoursePicture
}